import React from 'react';

const Footer = () => {
    return (
        <footer className="w-100 text-center my-5">
            <small> All Rights Reserved &copy; 2020 by Prionto Abdullah </small>
        </footer>
    );
};

export default Footer;